// Packages
import { Component, createRef } from "react";
import { Link, withRouter } from "react-router-dom";
// import axios from 'axios';
import { FormGroup } from "reactstrap";
// Views
import schoolAdminLogo from "../../assets/images/schoolAdminLogo.png";
import Footer from "../web/footer";
// Styles
import "../schoolAdminPortal/schoolAdmin.css";
// Assets
import footballplayer from "./images/football-player-image.png";
// Material Ui
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import PhotoSizeSelectActualOutlinedIcon from "@material-ui/icons/PhotoSizeSelectActualOutlined";
import Avatar from "@material-ui/core/Avatar";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { CircularProgress } from "@material-ui/core";
import successimg from "../../assets/images/successimg.png";
import laptop from "./images/laptop.png";
// Services
import userService from "../../services/user.service";
//Utils
import { getQueryparams } from "../../utils";
import { BsXLg } from "react-icons/bs";
import { Formik, Form, Field } from "formik";
import validationSchema from "../../Validation/ValidationSchemas";
import FailDialog from "./Popups/FailDialog";
import ImageUploadContainer from "../../Common/FormFields/ImageUploadContainer";

class AddAtheleteWebsite extends Component {
  constructor(props) {
    super(props);
    this.myref = createRef();
    this.state = {
      fields: {},
      errors: {},
      countryList: [],
      schoolTypeList: [],
      allSportsList: [],
      stateList: [],
      selectedCOuntry: "",
      countryId: null,
      jersey: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      graduation: "",
      state: "",
      schoolName: "",
      schoolType: "",
      sport: "",
      status: "",
      position: "",
      anyMessage: "",
      group: "",
      selectedFile: null,
      fileAddress: null,
      uploadId: null,
      imagePreviewUrl: "",
      submitting: false,
      inputString: "",
      value: "",
      schoolId: "",
      teamsDataTest: [],
      teamsData: [],
      groupsDataTest: [],
      groupsData: [],
      teamIds: [],
      phoneNumberLength: "",
      token: "",
      logoUrl: "",
      schoolIdSelected: "",
      schoolName: "",
      phonelengthError: false,
      instagramLink: "",
      twitterLink: "",
      disabled: false,
      failPopup: false,
    };

    this.handleChangestate = this.handleChangestate.bind(this);
    this.handleSubmissionForLogo = this.handleSubmissionForLogo.bind(this);
    this.changeHandlerForLogo = this.changeHandlerForLogo.bind(this);

    this.dropDownOptions = [
      { value: "2021", label: "2021" },
      { value: "2022", label: "2022" },
      { value: "2023", label: "2023" },
      { value: "2024", label: "2024" },
      { value: "2025", label: "2025" },
      { value: "2026", label: "2026" },
    ];
    this.onChange = this.onChange.bind(this);
  }
  //allow number logic for jersey no
  onChange(e) {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      this.setState({ value: e.target.value });
      this.setState({ jersey: e.target.value });
    }
  }
  handleChangestate(e) {
    this.setState({ stateid: e.target.value });
  }

  // for popup
  openDialog() {
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }
  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess, disabled: false });
  }

  componentDidMount() {
    const athlete = document.getElementById("Athlete");
    if (athlete) {
      athlete.classList.add("btnActive");
    }
    const {
      location: { search },
    } = this.props;
    let token = getQueryparams(search, "token");

    this.getSchoolDetailsViaToken(token);
  }
  getAllSportsList() {
    this.setState({
      submitting: true,
    });
    userService
      .getAllSports()
      .then((response) => {
        var allSportsList = response.data.data;
        this.setState({ allSportsList });
        console.log("allSportsList", allSportsList);
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }
  getschoolTypeList() {
    this.setState({
      submitting: true,
    });
    userService
      .getAllSchoolType()
      .then((response) => {
        var schoolTypeList = response.data.data;
        this.setState({ schoolTypeList });
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }
  getAllCountryList() {
    this.setState({
      submitting: true,
    });
    userService
      .getAllCountries()
      .then((response) => {
        var countryList = response.data.data;
        this.setState({ countryList });
        console.log("countryList", countryList);
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  getSchoolDetailsViaToken(data) {
    const token = data;
    userService
      .getSchoolDetailsViaToken(data)
      .then((response) => {
        var logoUrl = response.data.data.logoUrl;
        var schoolIdSelected = response.data.data.schoolId;
        var schoolName = response.data.data.schoolName;
        this.setState({
          logoUrl,
          schoolIdSelected,
          schoolName,
          schoolId: schoolIdSelected,
          token,
        });
        this.getAllGroupsData(schoolIdSelected);
        this.getAllTeamsData(schoolIdSelected);
      })
      .catch((error) => {});
  }

  changeHandlerForLogo = (file) => {
    this.setState({
      submitting: true,
    });
    const data = new FormData();
    data.append("file", file);
    userService.postLogoWithoutLogin(data).then((res) => {
      this.fileAddress = res.data.data[0].filePath;
      this.fileId = res.data.data[0].id;
      this.uploadId = res.data.data[0].id;
      this.setState({
        imagePreviewUrl: res.data.data[0].filePath,
        submitting: false,
      });
    });
  };

  handleSubmissionForLogo = () => {
    this.setState({
      submitting: true,
    });
    const data = new FormData();
    data.append("file", this.selectedFile);
    userService.postLogoWithoutLogin(data).then((res) => {
      this.fileAddress = res.data.data[0].filePath;
      this.fileId = res.data.data[0].id;
      this.uploadId = res.data.data[0].id;
      this.setState({
        submitting: false,
      });
    });
  };

  formatPhoneNumber(phNumber) {
    let cleaned = ("" + phNumber).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let inputString = "(" + match[1] + ") " + match[2] + "-" + match[3];
      this.myref.current.setFieldValue("phoneNumber", inputString);
    }
  }

  checkEmail(email) {
    if (email.length > 10) {
      let errors = {};
      let formIsValid = true;
      userService.checkEmailInUser(email).then((response) => {
        if (response.data.data === "true") {
          errors["email"] = "Email is already exist! Please try with another!";
          formIsValid = false;
          this.setState({ errors });
          this.setState({ formIsValid });
        } else {
          errors["email"] = "";
          formIsValid = true;
          this.setState({ errors });
          this.setState({ formIsValid });
        }
      });
    }
    let checkedEmail = email;
    this.setState({ email: checkedEmail });
  }

  getAllTeamsData(schoolIdSelected) {
    userService
      .getAllTeamDropdownWithotAuth(schoolIdSelected)
      .then((response) => {
        var teamsDataTest = response.data.data.teams;
        this.setState({ teamsDataTest });
        if (teamsDataTest != null) {
          var TeamsDisableFlag = true;
          this.setState({ TeamsDisableFlag });
          var teamsData = [];
          for (let i = 0; i < teamsDataTest.length; i++) {
            var obj = {};
            obj["name"] = teamsDataTest[i].teamName;
            obj["id"] = teamsDataTest[i].id;
            teamsData.push(obj);
          }
          this.setState({ teamsData }, () => {
            console.log("teamsData", this.state.teamsData);
          });
        } else {
          var TeamsDisableFlag = false;
          this.setState({ TeamsDisableFlag });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  onSelect = (selectedList, selectedItem) => {
    var teamIds = [];
    for (let i = 0; i < selectedList.length; i++) {
      teamIds.push(selectedList[i].id);
      this.setState({ teamIds }, () => {
        console.log("teamIds", this.state.teamIds);
      });
    }
  };
  onRemove = (selectedList, removedItem) => {
    var teamIds = [];
    for (let i = 0; i < selectedList.length; i++) {
      teamIds.push(selectedList[i].id);
      this.setState({ teamIds });
    }
  };
  onSelectGroups = (selectedList, selectedItem) => {
    var groupIds = [];
    for (let i = 0; i < selectedList.length; i++) {
      groupIds.push(selectedList[i].id);
      this.setState({ groupIds });
    }
  };
  onRemoveGroups = (selectedList, removedItem) => {
    var groupIds = [];
    for (let i = 0; i < selectedList.length; i++) {
      groupIds.push(selectedList[i].id);
      this.setState({ groupIds });
    }
  };

  getAllGroupsData(schoolIdSelected) {
    userService
      .getAllGroupsDropdownWithoutAuth(schoolIdSelected)
      .then((response) => {
        var groupsDataTest = response.data.data.groupDropdownDetailsResponses;
        this.setState({ groupsDataTest });
        if (groupsDataTest != null) {
          var groupsData = [];
          for (let i = 0; i < groupsDataTest.length; i++) {
            var obj = {};
            obj["name"] = groupsDataTest[i].groupName;
            obj["id"] = groupsDataTest[i].id;
            groupsData.push(obj);
          }
          this.setState({ groupsData }, () => {
            console.log("groupsData", this.state.groupsData);
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  toggleFailDialog = () => {
    this.setState({ failPopup: !this.state.failPopup });
  };

  registerSchoolAdmin({
    firstName,
    lastName,
    email,
    phoneNumber,
    positionPlayed,
    jerseyNumber,
    graduationYear,
    instaUrl,
    twitterUrl,
  }) {
    this.setState({ disabled: false });
    const { group, schoolId, groupIds, teamIds, token } = this.state;

    var obj = {};
    obj["firstName"] = firstName;
    obj["lastName"] = lastName;
    obj["email"] = email;
    obj["phoneNumber"] = phoneNumber;
    obj["jerseyNumber"] = jerseyNumber;
    obj["group"] = group;
    obj["uploadId"] = this.uploadId;
    obj["graduationYear"] = graduationYear;
    obj["schoolId"] = schoolId;
    obj["groupIds"] = groupIds;
    obj["teamIds"] = teamIds;
    obj["positionPlayed"] = positionPlayed;
    obj["instaUrl"] = instaUrl ? instaUrl : "";
    obj["twitterUrl"] = twitterUrl ? twitterUrl : "";

    var addAthleteRequest = obj;
    userService
      .AddAthleteDetailsWebsite(addAthleteRequest, token)

      .then((response) => {
        if (response.data.success === true) {
          this.openDialogSuccess();
          this.setState({ disabled: true });
        } else {
          if (response.data.data == "Link Is already used.") {
            this.setState({ failPopup: true });
          } else {
            this.myref.current.setFieldError(
              "email",
              "Email Id Is Used, Please Try with Different Email Id"
            );
          }
        }
        this.setState({
          submitting: false,
        });
      })

      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }
  render(props) {
    const {
      submitting,
      logoUrl,
      schoolName,
      imagePreviewUrl,
      fields,
      disabled,
      failPopup,
    } = this.state;

    return (
      <div>
        <Formik
          innerRef={this.myref}
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            positionPlayed: "",
            jerseyNumber: "",
            graduationYear: "",
            groupIds: this.state.groupIds,
            instaUrl: "",
            twitterUrl: "",
          }}
          validationSchema={validationSchema.athleteFormValidation}
          onSubmit={(values) => {
            this.registerSchoolAdmin(values);
          }}
        >
          {(formik) => (
            <>
              <Form>
                <CssBaseline />

                <div className="addSchool-innerHeaderAthelete">
                  <Toolbar>
                    <div className="col-8 col-sm-6 col-md-6 col-lg-6">
                      <div id="hideSectionBtn">
                        <Link to="/schooladmindata">
                          <img
                            src={schoolAdminLogo}
                            alt="Logo"
                            className="cp"
                            nowrap="true"
                          />
                        </Link>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      </div>
                    </div>
                    <div className="text-right col-6 col-sm-6 col-md-6 col-lg-6 mobileCancel">
                      <Dialog
                        id="dialogBoxsAddAthelete"
                        className="dialog-style"
                        open={this.state.open}
                        onClose={this.closeDialog.bind(this)}
                      >
                        <DialogTitle>
                          <div className="row">
                            <div className="col-1 text-right ml-auto ">
                              <BsXLg
                                onClick={this.closeDialog.bind(this)}
                                className="crossview cp"
                              ></BsXLg>
                            </div>
                          </div>
                        </DialogTitle>
                        <DialogContent>
                          <div className="clear10"></div>
                          <div className="row">
                            <div className="col-12 text-center">
                              <p className="fs-20 semi-bold text-center mb-4">
                                Are you sure you want to cancel?
                              </p>
                              <div className="clear10"></div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-right mr-3">
                              <button
                                type="button"
                                class="cancelbtn"
                                onClick={this.closeDialog.bind(this)}
                              >
                                No
                              </button>
                            </div>
                            <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-left mr-3">
                              <Link to="/schoolathletes">
                                <button type="button" class="yes-btn">
                                  Yes, Cancel
                                </button>
                              </Link>
                            </div>
                          </div>

                          <div className="clear10"></div>

                          <div className="clear10"></div>
                        </DialogContent>
                      </Dialog>

                      {/* sucess modal */}
                      <Dialog
                        id="dialogBoxCancel"
                        className="dialog-style"
                        open={this.state.openSuccess}
                        onClose={this.closeDialogSuccess.bind(this)}
                      >
                        <DialogTitle>
                          <div className="row">
                            <div className="col-1 text-right ml-auto ">
                              <BsXLg
                                onClick={this.closeDialogSuccess.bind(this)}
                                className="crossview cp"
                              ></BsXLg>
                            </div>
                          </div>
                        </DialogTitle>
                        <DialogContent>
                          <div className="clear10"></div>
                          <div className="row">
                            <div className="col-12 text-center">
                              <img
                                src={successimg}
                                alt="success"
                                className="successimg-new"
                              ></img>
                              <div className="clear20"></div>
                              <p className="fs-20 semi-bold text-center">
                                Athelete Successfully Added !
                              </p>
                              <div className="clear30"></div>
                            </div>
                            <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                              <Link to="/">
                                <button
                                  type="button"
                                  class="donebtn"
                                  onClick={this.closeDialogSuccess.bind(this)}
                                >
                                  Ok
                                </button>
                              </Link>
                            </div>
                          </div>

                          <div className="clear10"></div>

                          <div className="clear10"></div>
                        </DialogContent>
                      </Dialog>
                    </div>
                  </Toolbar>
                </div>

                <Toolbar />
                <div className="clear20"></div>
                <div className="add-athlete-container">
                  <div className="d-flex-center add-athlete-header">
                    <img
                      class="addathlete-website-logo"
                      src={logoUrl}
                      alt="School"
                    />
                    <h6 className="color-white mg-left-20 bold fs-22">
                      {schoolName}
                    </h6>
                  </div>

                  <div className="d-flex-space-around">
                    <div className="side-img-div">
                      <div className="text-center">
                        <img
                          alt=""
                          className="athlete-banner-img1"
                          src={laptop}
                        />
                      </div>

                      <div className="text-center">
                        <img
                          alt=""
                          className="athlete-banner-img2"
                          src={footballplayer}
                        />
                      </div>
                    </div>

                    <div>
                      <div className="clear20"></div>
                      <div>
                        <div>
                          <div>
                            <div className="white-card">
                              <ImageUploadContainer
                                id="upload-photo-1"
                                logoUrl={imagePreviewUrl}
                                handleUpload={(file) =>
                                  this.changeHandlerForLogo(file)
                                }
                                label={
                                  imagePreviewUrl
                                    ? "Update Profile Photo"
                                    : "Add Profile Photo"
                                }
                                loading={submitting}
                              />
                            </div>
                            <div className="clear20"></div>
                            <div className="white-card">
                              <div className="row fs-18 ">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold ">
                                          First Name{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <Field
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.firstName &&
                                            formik.touched.firstName &&
                                            "is-invalid"
                                          } `}
                                          type="text"
                                          name="firstName"
                                          placeholder="Enter First Name"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.firstName &&
                                            formik.errors.firstName}
                                        </div>
                                      </FormGroup>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold ">
                                          Last Name{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <Field
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.lastName &&
                                            formik.touched.lastName &&
                                            "is-invalid"
                                          }`}
                                          type="text"
                                          name="lastName"
                                          placeholder="Enter Last Name"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.lastName &&
                                            formik.errors.lastName}
                                        </div>
                                      </FormGroup>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold ">
                                          Email{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <Field
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.email &&
                                            formik.touched.email &&
                                            "is-invalid"
                                          }`}
                                          type="text"
                                          name="email"
                                          id="email"
                                          placeholder="Enter Email"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.email &&
                                            formik.errors.email}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                  <div className="clear10"></div>
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold ">
                                          Phone Number{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <Field
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.phoneNumber &&
                                            formik.touched.phoneNumber &&
                                            "is-invalid"
                                          }`}
                                          name="phoneNumber"
                                          maxlength="10"
                                          placeholder="Enter Phone Number"
                                          onKeyUp={(e) =>
                                            this.formatPhoneNumber(
                                              e.target.value
                                            )
                                          }
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.phoneNumber &&
                                            formik.errors.phoneNumber}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                  <div className="clear10"></div>
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold">
                                          Graduation Year{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <select
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel specialselect ${
                                            formik.errors.graduationYear &&
                                            "is-invalid"
                                          }`}
                                          name="graduationYear"
                                          value={fields.graduation}
                                          onChange={(event) => {
                                            formik.setFieldValue(
                                              "graduationYear",
                                              event.target.value
                                            );
                                          }}
                                        >
                                          <option value="">
                                            Select Graduation Year
                                          </option>
                                          {Array.isArray(
                                            this.dropDownOptions
                                          ) && this.dropDownOptions.length > 0
                                            ? this.dropDownOptions.map(
                                                (item) => {
                                                  return (
                                                    <option key={item.value}>
                                                      {item.label}
                                                    </option>
                                                  );
                                                }
                                              )
                                            : null}
                                        </select>
                                        <div className="errorMsg fs-14 medium">
                                          {formik.errors.graduationYear}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>

                                  <div className="clear10"></div>
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold">
                                          Position Played{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <Field
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.positionPlayed &&
                                            formik.touched.positionPlayed &&
                                            "is-invalid"
                                          }`}
                                          placeholder="Enter position"
                                          name="positionPlayed"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.positionPlayed &&
                                            formik.errors.positionPlayed}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                  <div className="clear10"></div>
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold">
                                          Jersey Number
                                          <span className="redstar">*</span>
                                        </label>
                                        <Field
                                          type="string"
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.jerseyNumber &&
                                            formik.touched.jerseyNumber &&
                                            "is-invalid"
                                          }`}
                                          placeholder="Enter Jersey Number"
                                          name="jerseyNumber"
                                          maxLength={3}
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.jerseyNumber &&
                                            formik.errors.jerseyNumber}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold font-18">
                                          Instagram
                                        </label>
                                        <Field
                                          name="instaUrl"
                                          type="text"
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.instaUrl &&
                                            "is-invalid"
                                          }`}
                                          placeholder="Enter Instagram Account Link"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.errors.instaUrl}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                  <div className="clear10"></div>

                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold font-18">
                                          Twitter
                                        </label>
                                        <Field
                                          type="text"
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.twitterUrl &&
                                            "is-invalid"
                                          }`}
                                          placeholder="Enter Twitter Account Link"
                                          name="twitterUrl"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.errors.twitterUrl}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                  <div className="clear10"></div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "right",
                                    }}
                                  >
                                    <button
                                      className="cancelbtn mr-2 cp "
                                      onClick={this.openDialog.bind(this)}
                                    >
                                      Cancel
                                    </button>

                                    <button
                                      type="submit"
                                      className={
                                        disabled == false
                                          ? "saveBtn1"
                                          : "saveBtn1 activv"
                                      }
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Footer />
              </Form>
              <FailDialog
                open={failPopup}
                closeFailDialog={this.toggleFailDialog}
                msg="This link is already used! Please use a new link!"
              />
            </>
          )}
        </Formik>
      </div>
    );
  }
}

export default withRouter(AddAtheleteWebsite);
